export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/5ba84b7c5997e2a9223c26a23a6fa17e.svg";